import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// Compartilhado entre `List.js` e `AuditDetailDrawer.js` — deriva o "balde"
// de cor/ícone (`StatusChip domain="auditAction"`) a partir do texto real de
// `action` devolvido pela API. Ver o comentário completo em
// `component/common/StatusChip.js` (domínio `auditAction`) sobre por que
// isso é necessário: a API devolve frases livres em português
// (`fv-api/*/{creator,updater,deleter,canceler,payer,operator}.go`,
// `user/auth.go`, `product/repositor.go`), não um código de status fechado.
// Qualquer verbo novo que apareça no futuro cai em "outro" em vez de quebrar.
export function classifyAuditAction(actionText) {
    const text = (actionText || '').trim().toLowerCase();
    if (!text) return 'outro';
    if (text.startsWith('realizou login')) return 'login';
    if (text.startsWith('criou') || text.startsWith('gerou') || text.startsWith('incluiu estoque')) return 'criou';
    if (text.startsWith('excluiu') || text.startsWith('cancelou') || text.startsWith('estornou') || text.startsWith('removeu estoque')) return 'excluiu';
    if (
        text.startsWith('atualizou') ||
        text.startsWith('aplicou') ||
        text.startsWith('iniciou') ||
        text.startsWith('finalizou') ||
        text.startsWith('registrou')
    ) return 'editou';
    return 'outro';
}

// Mesma interpretação de fuso já usada pela implementação anterior desta
// tela (`new Date(created_at).toLocaleString('pt-BR', { timeZone: 'UTC' })`)
// — só reescrita com `dayjs.utc` (já padrão nas telas redesenhadas) e
// separada em duas partes para o layout de duas linhas da coluna Data/Hora
// e para a aba Detalhes do drawer.
export function formatDateTimeUTC(dateString) {
    if (!dateString) return { datePart: '—', timePart: '' };
    const d = dayjs.utc(dateString);
    if (!d.isValid()) return { datePart: dateString, timePart: '' };
    return { datePart: d.format('DD/MM/YYYY'), timePart: d.format('HH:mm') };
}
